module.exports = __webpack_public_path__ + "img/arrow-left.a6cf1429.svg";